import { FileModel } from "@/types/common";
import { Video } from "./Video";
import { Image } from "./Image";
import { CrossIc } from "../Icons";

const UserImage = ({ file }: { file: FileModel }) => {
  return (
    <>
      <div className="m-5 h-[200px] w-[200px]">
        {file.isVideo ? (
          <Video apiSrc={file.fileUrl} className="w-full h-full" />
        ) : (
          <Image
            src={file.fileUrl}
            fileDataAsBase64={file.fileDataAsBase64}
            className="w-full h-full"
            isApiUrl
          />
        )}
      </div>
    </>
  );
};

export const ImageList = ({
  files,
  showRemove,
  handleChange,
}: {
  files: FileModel[];
  showRemove?: boolean;
  handleChange?: (value: FileModel[]) => void;
}) => {
  const handleRemoveImg = (index: number) => {
    if (handleChange) {
      let fileList = files.slice();
      fileList.splice(index, 1);
      handleChange(fileList);
    }
  };

  return (
    <>
      {files && files.length > 0 && (
        <div className="mt-2 flex flex-wrap">
          {files.map((file: FileModel, index: number) => (
            <div key={`f${index}`} className="relative">
              <UserImage file={file} />
              {showRemove && (
                <div
                  onClick={() => handleRemoveImg(index)}
                  className="absolute top-0 right-0 cursor-pointer"
                >
                  <CrossIc className="h-6 w-6 text-red-500" />
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </>
  );
};
